import React,{useState,useRef,useEffect} from 'react';
import {css} from 'emotion';
import IconEasyProfile from '../../../common/material-easy-ui/icon/IconEasyProfile'
import IconEasyConnexion from '../../../common/material-easy-ui/icon/IconEasyConnexion'
import Avatar from '../../../common/avatar';
import {useDispatch,useSelector} from 'react-redux';
import history from '../../../../utils/history';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const MenuAccount = (props) =>{
  const dispatch = useDispatch();
  const [hoverConnexion,setHoverConnexion] = useState(false);
  const [hoverProfile,setHoverProfile] = useState(false);
  const info_user = useSelector(state=>state.user.info_user)

  const disconnect = (e) =>{
    e.stopPropagation();
    dispatch({type:'DISCONNECT_USER'});
    localStorage.setItem('pnc_popkey',null);
}

const goToProfilePage = (e) =>{
  e.stopPropagation();
  history.push({pathname:'/profil'})
}


const refModal = useRef(null);

useEffect(()=>{
  disableBodyScroll(refModal);
    return () =>{
      clearAllBodyScrollLocks();
    }
},[])


  return(
    <div ref={refModal} className={css`z-index:200;width:100vw;height:100vh;background-color:rgba(59, 59, 59,0.2);position:fixed;left:0px;top:0px`}>
      <div onClick={props.hideMenuAccount} className={css`width:100%;height:100%;position:relative`}>
          <div className={css`background:white;width:200px;position:absolute;top:60px;right:20px;border-radius:10px;overflow:hidden`}>
            <div className={css`display:flex;align-items;center;padding-top:10px;padding-bottom:10px;box-sizing:border-box`}>
              <Avatar style={{height:'40px'}} id_avatar={parseInt(info_user.avatar, 10)}/>
              <div className={css`display:flex;flex-direction:column;font-size:12px;justify-content:center;margin-left:10px`}>
                <div className={css`color:#999999;text-overflow: ellipsis;width:145px;overflow-x:hidden`}>{info_user.pseudo}</div>
                <div className={css`color:#999999;text-overflow: ellipsis;width:145px;overflow-x:hidden`} >{info_user.email}</div>
              </div>
            </div>

            <div onClick={goToProfilePage} onMouseLeave={(e)=>setHoverProfile(false)}  onMouseEnter={(e)=>setHoverProfile(true)} className={css`cursor:pointer;background-color:${hoverProfile?'#0085C6':'none'};box-sizing:border-box;padding-top:5px;padding-bottom:5px;padding-left:10px;display:flex;align-items:center;border-top:1px solid #f5f5f5`}>
                <IconEasyProfile color={hoverProfile?'white':'#525252'} size={20}/>
                  <div className={css`margin-left:5px;font-size:14px;color:${hoverProfile?'white':'#525252'}`}>Profil</div>
            </div>
            <div onClick={disconnect} onMouseLeave={(e)=>setHoverConnexion(false)} onMouseEnter={(e)=>setHoverConnexion(true)} className={css`cursor:pointer;background-color:${hoverConnexion?'#0085C6':'none'};box-sizing:border-box;padding-top:5px;padding-bottom:5px;padding-left:10px;;border-top:1px solid #f5f5f5;display:flex;align-items:center`}>
                    <IconEasyConnexion color={hoverConnexion?'white':'#525252'} size={20}/>
                  <div className={css`margin-left:5px;font-size:14px;color:${hoverConnexion?'white':'#525252'}`}>Déconnexion</div>
            </div>
          </div>
      </div>
    </div>
  )
}

export default MenuAccount;
